import { Component, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { Socket } from 'ngx-socket-io';
import { ToastrService } from 'ngx-toastr';
import { Subject, interval, take, takeUntil } from 'rxjs';
import { KeyWord } from 'src/app/shared/classes/constants';
import { KeywordData } from 'src/app/shared/classes/keywordData';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { EditorService } from 'src/app/shared/services/editor.service';
import { ThemingService } from 'src/app/shared/services/theming.service';
import Swal from 'sweetalert2';
import moment from 'moment';
import { BulkAuditComponent } from '../bulk-audit/bulk-audit.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class DashboardComponent implements OnInit, OnDestroy {
  @ViewChild('globalSettings') defaultSettings: any;
  globalSettingsSelectedCountry = "United States";
  selectedglobalSettingsFlag: string = "";
  defaultGlobalSettingsFlag: string = "https://flagpedia.net/data/flags/normal/us.png";
  globalSettingslanguageType: string = "en";

  unCompletedCount: any = []
  startdate: any = new Date();
  bStartdate: any = new Date();
  viewByTag: any = "All";
  loading: boolean = false
  selectedTagAry: any = []
  selectedAid: any = ""
  uid: any = ""
  tagArrayBackup: any[] = [];
  tagArray: any[] = [];
  auditForm!: FormGroup;
  activateLink: string = 'Audit report list';
  panelOpenState: boolean = false;
  count: number = 0;
  addTag = new FormControl('');
  RenameTag = new FormControl('');
  profileImages = KeyWord.profileImages;
  countries = KeyWord.editorAuditCountry;
  flags = KeyWord.flags;
  deviceType = KeyWord.deviceType;
  keywords = KeyWord.keywords;
  keyWordData: KeywordData[] = [];
  backupKeyWordData: any = [];
  dropDownCountry = KeyWord.editorAuditCountry;
  languageDropdown = KeyWord.editorAuditLanguages;
  isRunnnig: boolean = false;
  isCreateContentMinimize: boolean = false;
  selectedFlag = "";
  contentData: KeywordData = {};
  index: number = 0;
  selectedValue: string = "All";
  countryValue: string = "United States:us";
  crawlType: string = "Desktop";
  languageType: string = "en";
  nlp: boolean = true;
  selected = "United States";
  theme: boolean = true;
  auditData: any[] = [];
  dataObj1: any = {}
  defaultFlag = "https://flagpedia.net/data/flags/normal/us.png";
  // public myreg = /(^|\s)((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/gi;
  public myreg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  date = new Date();
  numbers = interval(100);
  backupAuditData: any[] = [];
  totalCredits: any = "0";
  remainingCredits: any = "0";
  percent_remaining: any = "0";
  currentAudit: any[] = [];
  allTagsArray: any = []
  updateTagAry: any = []
  tagCounts: any = {};
  dropDownCountryGlobal = KeyWord.editorAuditCountry;
  languageDropdownGlobal = KeyWord.editorAuditLanguages;
  globalSettingsObj:any;
  private readonly _stop = new Subject<void>();

  get className() {
    return !this.theme ? 'tag-menu' : ''
  }

  get selectMenu() {
    return !this.theme ? 'testClass' : 'selectMenu'
  }

  get menu() {
    return !this.theme ? 'providers-menu' : ''
  }

  get popover() {
    return !this.theme ? 'dark-popover ' : ''
  }
  createdDate(date: any) {
    return moment(date);
  }
  constructor(
    private modal: NgbModal,
    private fb: FormBuilder,
    private themingService: ThemingService,
    private router: Router,
    private editorServie: EditorService,
    private cookieServ: CookieService,
    private toster: ToastrService,
    private socket: Socket,

  ) {
    this.startdate.setMinutes(this.startdate.getMinutes() - 5);
    this.bStartdate.setMinutes(this.startdate.getMinutes() - 30);
    this.themingService.getThemeName().subscribe((res: any) => {
      this.theme = res
    })
    // this.themingService.nameKeeper.subscribe(val => this.theme = val)
    this.uid = this.cookieServ.get("uid");
    // this.uid = "u-8842b392-d3ae-11ed-bbac-7738ed7ada70";
    if (!this.uid || !localStorage.getItem('auth_token')) {
      this.router.navigate([`login`])
    }
    this.socket.on('auditCompleted', (data: any) => {
      if (!!data && !!data.data) {
        this.getData();
      }
    })
  }

  // @HostListener('window:scroll', ["$event"])
  // onWindowScroll() {
  //   const triggerAt: number = 1;
  //   if (document.body.scrollHeight - (window.innerHeight + window.scrollY) <= triggerAt) {
  //     setTimeout(() => {
  //       let fromStart = this.auditData.length;
  //       let startingINdex = this.backupAuditData.slice(fromStart, fromStart + 20);
  //       this.currentAudit = [...this.auditData, ...startingINdex];
  //       this.auditData = [...this.auditData, ...startingINdex];
  //       this.getFilteredData()
  //       // this.getData();
  //       // this.selectedValue = "All";
  //     }, 1000);
  //   }
  // }
  @HostListener('document:mousewheel', ['$event'])
  @HostListener('document:DOMMouseScroll', ['$event'])

  onDocumentMousewheelEvent(event: any) {
    const triggerAt: number = 1;
    if (document.body.scrollHeight - (window.innerHeight + window.scrollY) <= triggerAt) {
      setTimeout(() => {
        let fromStart = this.auditData.length;
        let startingINdex = this.backupAuditData.slice(fromStart, fromStart + 20);
        this.currentAudit = [...this.auditData, ...startingINdex];
        this.auditData = [...this.auditData, ...startingINdex];
        this.getFilteredData()
        // this.getData();
        // this.selectedValue = "All";
      }, 2000);
    }
  }

  ngOnInit(): void {
    this.themingService.pingThemeName();
    this.getAuditTagData()
    this.getData();
    this.initContentEditorForm();
    this.getGlobalSettingData();
    // this.tagArray = KeyWord.tagArray;
    // this.tagArray = this.tagArray.map(tag => {
    //   return { tag, counter: Math.floor(Math.random() * 99) + 1 }
    // })
  }
  ngOnDestroy() {
    this.socket.removeListener("auditCompleted");
  }

  initContentEditorForm() {
    this.auditForm = this.fb.group({
      keyWord: ['', Validators.required],
      url: ['', [Validators.required, Validators.pattern(this.myreg)]],
    })
  }
  checkEnter(event: any, arg: string) {
    let code = KeyWord.editorAuditCountry.find(e => {
      return e.country == event.target.innerText
    })?.code
    let countryCode = code?.split(":")[1];
    if (arg === 'country') {
      let x: any = KeyWord.editorAuditCountry.find(v => v.country == this.selected)
      this.countryValue = `${x.country}:${x.code.split(':')[1]}`;
      this.selectedFlag = `https://flagpedia.net/data/flags/normal/${countryCode}.png`;
    } else {
      this.selectedglobalSettingsFlag = `https://flagpedia.net/data/flags/normal/${countryCode}.png`
    }

  }
  getAuditTagData() {
    if (this.uid != "") {
      this.editorServie.getContentTagByUser({ uid: this.uid, type: "AUDIT" }).subscribe((res: any) => {
        try {
          if (res.auditTag.length != 0) {
            this.tagArrayBackup = Array.isArray(res.auditTag[0].contentTags) ? res.auditTag[0].contentTags : []
            this.tagArray = Array.isArray(res.auditTag[0].contentTags) ? res.auditTag[0].contentTags : []
          }
        } catch (error) {

        }
      })
    }
  }

  submitAudit() {
    // if(this.unCompletedCount.length > 5){
    //   // this.toster.warning('You can generating more then 5 keywords before analyze any one')
    //   return
    // }
    if (this.auditForm.valid) {
      this.dataObj1 = {
        type: "POST",
        uid: this.uid,
        keyword: this.auditForm.controls['keyWord'].value,
        url: this.auditForm.controls['url'].value,
        location: this.countryValue,
        device: this.crawlType,
        language: this.languageType,
        nlp: this.nlp ? "nlp" : "",
        bulk: 'false'
      };
      this.editorServie.getAndPostAudit(this.dataObj1).subscribe(res => {
        this.auditForm.reset()
        if (!!res) {
          this.socket.emit("updater", res?.aid);
        }
      })
    }
  }

  bulkContent() {
    const modalRef = this.modal.open(BulkAuditComponent, { centered: true, windowClass: !this.theme ? 'dark-modal custom-modal' : 'custom-modal' });
    modalRef.componentInstance.country = this.selected;
    modalRef.componentInstance.language = this.languageType;
    modalRef.result.then(e => {
      if (!!e && e !== undefined) {
        let obj = {
          "type": "POST",
          "uid": this.uid,
          "bulkAry": e,
          "retry": "false",
          "aid": "",
          "bulk": "true"
        }
        this.editorServie.getAndPostAudit(obj).subscribe(res => {
          if (res?.message && res.status == false) {
            this.toster.error(res.message)
          }
          if (!!res && res?.aid?.length > 0) {
            res.aid.forEach((el: any) => {
              this.socket.emit("updater", el);
            });
            this.getData();
          }
        });
      }
    });

  }

  retryAudit(data: any) {
    this.editorServie.completeAudit({ req_type: "retry", uid: this.uid }, data.aid).subscribe(res => {
      if (!!res) {
        this.socket.emit("updater", res?.aid);
      }
    })
  }

  getData() {
    this.loading = true
    this.isCreateContentMinimize = false;
    this.count = 0;
    let data = {
      type: "GET",
      uid: this.uid,
    };
    this.editorServie.getAndPostAudit(data).subscribe(res => {
      this.unCompletedCount = res?.audits?.filter((v: any) => v.status == 'Loading' && v.is_bulk == true && this.bStartdate < this.createdDate(v.created))
      this.loading = false
      this.auditData = res.audits.slice(0, 20);
      this.currentAudit = res.audits.slice(0, 20);
      this.backupAuditData = res.audits;
      this.totalCredits = res.max_credits,
        this.remainingCredits = res.my_credits
      this.allTagsArray = []
      this.tagCounts = {}
      this.backupAuditData.forEach((v: any) => {
        v.auditTag.forEach((c: any) => {
          this.allTagsArray.push(c.tag)
        })
      })
      this.allTagsArray.forEach((x: any) => { this.tagCounts[x] = (this.tagCounts[x] || 0) + 1; });

      if (this.totalCredits == "inf") {
        this.percent_remaining = 100
      } else if (this.totalCredits != "0") {
        this.percent_remaining = ((this.totalCredits - this.remainingCredits) * 100 / this.totalCredits)
      } else {
        this.percent_remaining = 0
      }
      this.getFilteredData('initialLoad')
    })
  }
  getSelectedFlag(code: any, country: any, type: any) {
    if (type == '') {
      this.selectedFlag = `https://flagpedia.net/data/flags/normal/${code}.png`;
      this.countryValue = `${country}:${code}`;
    } else if (type == 'globalSetting') {
      this.selectedglobalSettingsFlag = `https://flagpedia.net/data/flags/normal/${code}.png`;
    }
  }

  randomDate(start: Date, end: Date) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  }

  activeLink(data: string) {
    this.activateLink = data;
  }

  deleteTag(tag: any) {
    if (this.uid != "") {
      Swal.fire({
        title: 'Are you sure want to remove this tag?',
        // text: 'You will not be able to recover this file!',  
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No'
      }).then((willDelete: any) => {
        if (willDelete.value) {
          this.tagArrayBackup = this.tagArrayBackup.filter((v: any) => v.tag != tag);
          this.tagArray = this.tagArray.filter((v: any) => v.tag != tag);
          const data = {
            tag: this.tagArrayBackup,
            uid: this.uid,
            type: "AUDIT"
          }
          this.loading = true
          this.editorServie.addContentTag(data).subscribe((res: any) => {
            try {
              this.loading = false
              if (res) {
                this.backupAuditData.forEach((v: any) => {
                  v.auditTag.forEach((c: any) => {
                    if (c.tag == tag) {
                      let x = v.auditTag.filter((x: any) => x.tag != tag)
                      this.updateTagAry.push({ aid: v.aid, tags: x })
                    }
                  })
                })
                if (this.updateTagAry.length != 0) {
                  this.loading = true
                  this.editorServie.deleteTagByAid({ tags: this.updateTagAry, type: "AUDIT" }).subscribe((res: any) => {
                    try {
                      this.loading = false
                      if (res) {
                        this.getData()
                        this.updateTagAry = []
                        this.toster.success("tag delete successfully")
                      }
                    } catch (error: any) {
                      this.toster.error(error.message)
                    }
                  })
                } else {
                  this.toster.success("tag delete successfully")
                }
              }
            } catch (error: any) {
              this.toster.error(error.message)
            }
          })
        } else {
          Swal.fire(
            'Cancelled',
            'error'
          )
        }
      });
    }
  }
  retryKeyword: any = ''
  openCreateContentModal(content: any, retryKeyword = '') {
    // if(this.unCompletedCount.length > 5 && retryKeyword == "" ){
    //   // this.toster.warning('You can generating more then 5 keywords before analyze any one')
    //   return
    // }
    this.retryKeyword = retryKeyword
    this.isCreateContentMinimize = false;
    this.isRunnnig = true;
    this.count = 0;
    this.modal.dismissAll();
    this.modal.open(content, { centered: true, windowClass: !this.theme ? 'dark-modal' : '' });
    const numbers = interval(100);
    const takeFourNumbers = this.numbers.pipe(takeUntil(this._stop),
      take(101));
    takeFourNumbers.subscribe((x: any) => {
      this.count = x;
      if (this.count === 100) {
        this.isCreateContentMinimize = false;
        setTimeout(() => {
          this.minimizeCreateContentModal();
          this.searchDropDownData('', 'country');

          if(this.globalSettingsObj?.length > 0){
            this.selected = this.globalSettingsObj[0].auditCountry;
            this.languageType = this.globalSettingsObj[0].auditLanguage
            let code = KeyWord.editorAuditCountry.find(v => v.country === this.globalSettingsObj[0].auditCountry)?.code;
            code = code?.split(':')[1];
            this.selectedFlag = `https://flagpedia.net/data/flags/normal/${code}.png`;
            let x: any = KeyWord.editorAuditCountry.find(v => v.country == this.selected)
            this.countryValue = `${x.country}:${x.code.split(':')[1]}`;
          }else{
            this.selected = "United States";
            this.selectedFlag = "https://flagpedia.net/data/flags/normal/us.png";
            let x: any = KeyWord.editorAuditCountry.find(v => v.country == this.selected)
            this.countryValue = `${x.country}:${x.code.split(':')[1]}`;
            this.languageType = "en";
          }
          
          this.crawlType = "Desktop";
          // this.getGlobalSettingData()
          this.getData();
          this.count = 0
          this.isRunnnig = false;
          // this.addData();
          // this.postData();

          this._stop.next();
        }, 200);
      }
    });
  }

  minimizeCreateContentModal() {
    this.modal.dismissAll();
    this.isCreateContentMinimize = true;
    this.auditForm.reset();

    // this.dataObj()
  }

  addData() {
    this.modal.dismissAll();
    this.dataObj();
    this.keyWordData.unshift(this.contentData);
    if (this.keyWordData.length % 2 != 0) {
      this.keyWordData.pop();
    }
    // this.editorServie.postAuditKeyword(this.dataObj()).subscribe(res=>{
    // })
    this.initContentEditorForm();
    this.selectedFlag = '../assets/images/australia.png';
    this.count = 0;
  }

  dataObj() {
    // return this.contentData = {
    //   'keyWord': this.addContentEditorForm.controls['keyWord'].value,
    //   'email': Math.round(Math.random() * 100000) + '@email.com',
    //   "profileImage": this.profileImages[Math.floor(Math.random() * this.profileImages.length)],
    //   'date': new Date(),
    //   'url':this.addContentEditorForm.controls['url'].value,
    //   'country': this.addContentEditorForm.controls['country'].value,
    //   'device': this.addContentEditorForm.controls['device'].value,
    //   'language':this.addContentEditorForm.controls['language'].value,
    //   'nlp':this.addContentEditorForm.controls['nlp'].value==true ? "on" : "off",
    //   'flag': this.flags[this.countries.indexOf(this.addContentEditorForm.controls['country'].value)],
    //   'progress': Math.floor(Math.random() * 100) + 1,
    // }
  }
  getFilteredData(arg?: string) {
    if (!arg || arg === "" || arg === 'sortArg' || arg == "ViewByTag") {
      this.auditData = this.currentAudit;
    }
    let filteredData = this.auditData;
    if (!!this.viewByTag && this.viewByTag !== "All") {
      filteredData = filteredData?.filter(v => v?.auditTag?.find((a: any) => a.tag == this.viewByTag))
    }
    if (this.viewByTag == "All" && arg == "ViewByTag") {
      filteredData = filteredData
    }
    if (this.selectedValue && this.selectedValue === 'Mobile only') {
      filteredData = filteredData.filter(e => e.device === 'Mobile')
    } else if (this.selectedValue && this.selectedValue === 'Desktop only') {
      filteredData = filteredData.filter(e => e.device === 'Desktop')
    } else {
      this.auditData = filteredData;
    }
    this.auditData = filteredData;
  }
  openModal(title: string, tag?: string, index?: number) {
    const modalRef = this.modal.open(ModalComponent, { centered: true, windowClass: !this.theme ? 'dark-modal' : '', backdropClass: 'tag-modal' });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.index = index;
    modalRef.componentInstance.data = tag;
    if (title)
      modalRef.result.then(e => {
        if (title === 'RenameTag') {
          if (this.uid != "") {
            this.tagArray[e.index].tag = e.data
            this.tagArrayBackup[e.index].tag = e.data
            const data = {
              tag: this.tagArrayBackup,
              uid: this.uid,
              type: "AUDIT"
            }
            this.loading = true
            this.editorServie.addContentTag(data).subscribe((res: any) => {
              try {
                this.loading = false
                if (res) {
                  for (let i = 0; i < this.backupAuditData?.length; i++) {
                    if (this.backupAuditData[i]?.auditTag?.length != 0) {
                      for (let j = 0; j < this.backupAuditData[i]?.auditTag?.length; j++) {
                        if (this.backupAuditData[i]?.auditTag[j]?.tag == tag) {
                          this.backupAuditData[i].auditTag[j].tag = e.data
                          this.updateTagAry.push({ aid: this.backupAuditData[i].aid, tags: this.backupAuditData[i].auditTag })
                        }
                      }
                    }
                  }
                  if (this.updateTagAry.length != 0) {
                    this.loading = true
                    this.editorServie.deleteTagByAid({ tags: this.updateTagAry, type: "AUDIT" }).subscribe((res: any) => {
                      try {
                        this.loading = false
                        if (res) {
                          this.updateTagAry = []
                          this.getData()
                          this.getAuditTagData()
                          this.toster.success("tag update successfully")
                        }
                      } catch (error: any) {
                        this.toster.error(error.message)
                      }
                    })
                  } else {
                    this.toster.success("tag update successfully")
                    this.getData()
                    this.getAuditTagData()
                  }
                }

              } catch (error: any) {
                this.toster.error(error.message)
              }
            })
          }
        } else if (title === 'AddTag' && this.uid != "") {
          let obj = {
            tag: e,
            counter: 0
          }
          this.tagArrayBackup.push(obj)
          // this.tagArray.push(obj);
          const data = {
            tag: this.tagArrayBackup,
            uid: this.uid,
            type: "AUDIT"
          }
          this.loading = true
          this.editorServie.addContentTag(data).subscribe((res: any) => {
            try {
              this.loading = false
              if (res) {
                this.getAuditTagData()
                this.toster.success("tag data save successfully")
              }
            } catch (error: any) {
              this.toster.error(error.message)
            }
          })
        }
      })
  }
  searchDropDownData(event?: any, arg?: string) {
    let key: any;
    if (!!event) {
      key = event.target.value.toLowerCase();
    } else {
      key = ''
    } if (arg == 'country') {
      this.dropDownCountry = KeyWord.editorAuditCountry.filter(e => {
        return e.country.toLowerCase().search(key) >= 0
      })
    } else if (arg == 'language') {
      this.languageDropdown = KeyWord.editorAuditLanguages.filter(e => {
        return e.name.toLowerCase().search(key) >= 0
      })
    }
  }
  searchDropDownDataGlobal(event?: any, arg?: string) {
    let key: any;
    if (!!event) {
      key = event.target.value.toLowerCase();
    } else {
      key = ''
    }
    if (arg == 'country') {
      this.dropDownCountryGlobal = KeyWord.editorAuditCountry.filter(e => {
        return e.country.toLowerCase().search(key) >= 0
      })
    } else if (arg == 'language') {
      this.languageDropdownGlobal = KeyWord.editorAuditLanguages.filter(e => {
        return e.name.toLowerCase().search(key) >= 0
      })
    }
  }
  navigateToAuditDetail(id: string) {
    this.router.navigate([`dashboard/audit-report/audit/${id}`])
  }

  openAddTagModel(content: any, aid: any) {
    this.selectedAid = aid
    this.modal.open(content, { centered: true, windowClass: !this.theme ? 'dark-modal' : '' });
  }

  addTagByAid() {
    this.selectedTagAry = this.selectedTagAry.map((tag: any) => {
      return { tag: tag.tag, counter: 0 }
    });
    this.selectedAid
    if (this.selectedAid != "" && this.selectedTagAry.length != 0) {
      this.loading = true
      this.editorServie.saveTagByAid({ aid: this.selectedAid, tags: this.selectedTagAry, type: "AUDIT" }).subscribe((res: any) => {
        try {
          this.loading = false
          if (res) {
            this.selectedAid = "";
            this.selectedTagAry = []
            this.getData()
            this.modal.dismissAll();
            this.toster.success("tag data save successfully")
          }
        } catch (error) {

        }
      })
    }
  }

  removeTag(selectTagAry: any, tagName: any, aid: any) {
    let ary = selectTagAry.filter((v: any) => v.tag != tagName)

    this.loading = true
    this.editorServie.removeTabById({ aid: aid, tags: ary, type: "AUDIT" }).subscribe((res: any) => {
      try {
        if (res) {
          this.loading = false
          this.getData()
          this.toster.success("tag delete successfully")
        }
      } catch (error) {

      }
    })
  }

  deleteEditorReport(aid: any) {
    if (!aid) {
      this.toster.error("report id not available")
      return
    }
    Swal.fire({
      title: 'Are you sure want to dalete this report?',
      // text: 'You will not be able to recover this file!',  
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((willDelete: any) => {
      if (willDelete.value) {
        this.loading = true
        const data = {
          aid: aid,
          type: "AUDIT"
        }
        this.editorServie.deleteReportByAid(data).subscribe((res: any) => {
          try {
            this.loading = false
            if (res) {
              this.getData()
              this.getAuditTagData()
              Swal.fire(
                'Deleted!',
                'success'
              )
            }
          } catch (error: any) {
            this.toster.error(error.message)
          }
        })
      } else {
        Swal.fire(
          'Cancelled',
          'error'
        )
      }
    });
  }


  globalSetting() {
    let globalModel = this.modal.open(this.defaultSettings, { centered: true, size: 'sm', backdrop: 'static', keyboard: false, windowClass: !this.theme ? 'dark-modal' : '' });
  }
  updateSettings() {
    let Obj = {
      type: "audit",
      uid: this.uid,
      language: this.globalSettingslanguageType,
      country: this.globalSettingsSelectedCountry,
    }

    this.editorServie.seveGlobalSetting(Obj).subscribe((res: any) => {
      if (res.success) {
        this.modal.dismissAll()
        this.getGlobalSettingData()
        this.toster.success('Default setting saved successfully')
      }
    })

  }

  getGlobalSettingData() {
    this.editorServie.getGlobalSettingData({ "uid": this.uid }).subscribe(res => {
      if (res && res.globalSetting.length != 0 && res.globalSetting[0].auditCountry != null) {
        let data = res.globalSetting[0]
        this.globalSettingsObj = res.globalSetting;
        this.globalSettingslanguageType = data.auditLanguage
        let code = KeyWord.editorAuditCountry.find(v => v.country === data.auditCountry)?.code;
        code = code?.split(':')[1];
        this.selectedFlag = `https://flagpedia.net/data/flags/normal/${code}.png`;
        this.defaultFlag = `https://flagpedia.net/data/flags/normal/${code}.png`;
        this.selectedglobalSettingsFlag = `https://flagpedia.net/data/flags/normal/${code}.png`;
        this.languageType = data.auditLanguage
        this.globalSettingsSelectedCountry = data.auditCountry
        this.selected = data.auditCountry
        let x: any = KeyWord.editorAuditCountry.find(v => v.country == this.selected)
        this.countryValue = `${x.country}:${x.code.split(':')[1]}`;
      } else {
        this.globalSettingslanguageType = "en"
        // let code = KeyWord.editorAuditCountry.find(v => v.country === data.auditCountry)?.code;
        // code = code?.split(':')[1];
        this.selectedFlag = `https://flagpedia.net/data/flags/normal/us.png`;
        this.defaultFlag = `https://flagpedia.net/data/flags/normal/us.png`;
        this.selectedglobalSettingsFlag = `https://flagpedia.net/data/flags/normal/us.png`;
        this.languageType = "en"
        this.globalSettingsSelectedCountry = "United States"
        this.selected = "United States"
        this.countryValue = "United States:us";
      }
    })
  }

}
